<template><ArticlePage page="terms" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/terms.js';
export default { name: 'Terms', components: { ArticlePage }, data: () => ({ content }) };
</script>
